/**
 * Inherited-vs-native cutoff for clone-owned Variant Mapping rows.
 *
 * Copy-on-clone preserves source `created_at` / `asserted_at`. A later cutoff
 * edit only updates `organisations.data_cutoff_date` — it does not recopy.
 * Inherited rows (copied from the source, timestamped before the clone existed)
 * are hidden when they fall after the cutoff. Clone-native writes
 * (`row.created_at >= organisations.created_at`) bypass cutoff, matching
 * clone-owned CSV connections.
 */

export function isCloneNativeMappingRow(
  rowTimestamp: string | null | undefined,
  orgCreatedAt: string | null | undefined,
): boolean {
  if (!rowTimestamp || !orgCreatedAt) return false;
  const rowMs = Date.parse(rowTimestamp);
  const orgMs = Date.parse(orgCreatedAt);
  if (Number.isNaN(rowMs) || Number.isNaN(orgMs)) return false;
  return rowMs >= orgMs;
}

export function inheritedMappingRowVisible(
  rowTimestamp: string | null | undefined,
  orgCreatedAt: string | null | undefined,
  cutoffDate: string | null | undefined,
): boolean {
  if (isCloneNativeMappingRow(rowTimestamp, orgCreatedAt)) return true;
  if (!cutoffDate) return true;
  if (!rowTimestamp) return true;
  return rowTimestamp.slice(0, 10) <= cutoffDate;
}

export function observationTimestamp(
  row: { asserted_at?: string | null; created_at?: string | null },
): string | null {
  return row.asserted_at ?? row.created_at ?? null;
}

export interface CloneMappingReadFilter {
  orgCreatedAt: string | null;
  cutoffDate: string | null;
}
